import axios from 'axios';
import { IMOURisk } from '../contracts/mou-risk.contract';
import ConfigService from './config.service';

const getByIMONumber = async (imoNumber: string): Promise<IMOURisk[]> => {
    imoNumber = imoNumber.replace('/', '');
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/MOU/Vessel/${imoNumber}`);
    return res.data;
};

const MOURiskService = {
    getByIMONumber
};

export default MOURiskService;
